export enum FlowType {
  ISSUANCE = 'issuance',
  REFRESH = 'refresh',
  REFRESH_EXPIRED_CREDENTIAL = 'refreshExpiredCredential',
  STATUS = 'status',
  REVOCATION = 'revocation',
  UNFREEZE = 'unfreeze',
}
export enum FlowStatus {
  IN_PROGRESS = 'in-progress', // when the user has initiated a flow that is ongoing
  RESULT = 'result', // when the user has completed a flow and the result is available for display
  FINISHED = 'finished', // when the user has completed a flow and has closed the display
}
